function deepCopy(obj) {
  var newobj = Array.isArray(obj) ? [] : {};
  if (Object.prototype.toString.call(obj) != '[object Object]' && Object.prototype.toString.call(obj) !=
      '[object Array]') {
      return obj;
  } else {
      for (var i in obj) {
          if ((Object.prototype.toString.call(obj) == '[object Object]' || Object.prototype.toString.call(obj) ==
                  '[object Array]') && obj[i] !== null) { //判断对象的这条属性是否为对象

              newobj[i] = deepCopy(obj[i]); //若是对象进行嵌套调用
          } else {
              newobj[i] = obj[i];

          }
      }
  }
  return newobj; //返回深度克隆后的对象
}
export default deepCopy;



// WEBPACK FOOTER //
// ./src/commons/my-plug/deep-copy.js